import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-not-found-page',
  standalone: true,
  imports: [RouterModule],
  template: `
    <section class="not-found">
      <h1>Page not found</h1>
      <p>The page you requested doesn’t exist.</p>
      <p><a routerLink="/">Go to Doctogenic home</a></p>
    </section>
  `,
  styles: [
    `
      .not-found {
        padding: 2rem 1rem;
        max-width: 60rem;
        margin: 0 auto;
      }
    `,
  ],
})
export class NotFoundPageComponent {}
